module.exports = __webpack_public_path__ + "static/media/notification.3c2257f5.svg";